import { Wifi, WifiOff, ServerCrash, EyeOff, Power, Building2, HelpCircle } from "lucide-react";

export const CAUSE_META = {
  network: { label: "Wi-Fi / network dropped", icon: WifiOff, cls: "bg-cyan-100 text-cyan-700 dark:bg-cyan-950/40 dark:text-cyan-300", bar: "bg-cyan-500" },
  unreachable: { label: "Couldn't reach The Good Box", icon: Wifi, cls: "bg-orange-100 text-orange-700 dark:bg-orange-950/40 dark:text-orange-300", bar: "bg-orange-500" },
  server: { label: "The Good Box system issue", icon: ServerCrash, cls: "bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300", bar: "bg-rose-600" },
  hidden: { label: "Screen locked / browser in background", icon: EyeOff, cls: "bg-sky-100 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300", bar: "bg-sky-500" },
  restart: { label: "Tablet restarted or browser closed", icon: Power, cls: "bg-violet-100 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300", bar: "bg-violet-500" },
  system_wide: { label: "System / building-wide issue", icon: Building2, cls: "bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-950/40 dark:text-fuchsia-300", bar: "bg-fuchsia-600" },
  unknown: { label: "Unknown", icon: HelpCircle, cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300", bar: "bg-slate-400" },
};

export const humanSecs = (s) => {
  s = Math.max(0, Math.round(s || 0));
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  if (d) return `${d}d ${h}h`;
  if (h) return `${h}h ${m}m`;
  return `${Math.max(m, s ? 1 : 0)}m`;
};

export const CauseBadge = ({ cause, testid }) => {
  const meta = CAUSE_META[cause] || CAUSE_META.unknown;
  const Icon = meta.icon;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${meta.cls}`}>
      <Icon className="h-3 w-3" /> {meta.label}
    </span>
  );
};
